The geographical coordinates of the address.
